import React from 'react';
import {observer} from 'mobx-react';
import s from '../../s';
import {SubHeaderDisclosure} from '../disclosure/sub-header-disclosure';
import DescMainContent from './desc-main-content';

const DescMain: React.FC = observer(() => {
    if (!s.ready) {
        return null;
    }

    return (
        <div id="prod-desc">
            <SubHeaderDisclosure
                buttonId="prod-main-desc"
                panelId="prod-main-desc-inner"
                title="Description"
                defaultOpen={true}
                panelStyle={{height: 'auto', maxHeight: 'inherit'}}
            >
                {<DescMainContent />}
            </SubHeaderDisclosure>
        </div>
    );
});

export default DescMain;
